<template>
    <div class="sidebar" >
        <div class="logo" :hidden="closeFag" >
            <img :src="stationLogo" class='logoImg'  />
            <p class="logoTitle" :hidden="collapse" >{{stationName}}</p>
            <i class="el-icon-close close" @click="collapseChage" ></i>
        </div>
        <el-menu class="sidebar-el-menu" :default-active="onRoutes" :collapse="collapse"  @select="handleselect" unique-opened router >
            <template v-for="item in items">
                <template v-if="item.subs">
                    <el-submenu :index="item.index" :key="item.index">
                        <template class="el-menu-item" slot="title" >  
                            <div  class="el-item" style="margin-left:-20px;padding-left:20px;">
                            <i :class="item.icon"></i>
                            <span slot="title">{{ item.title }}</span>  
                            </div>
                        </template>
                        <template class="el-menu-item" v-for="subItem in item.subs">
                            <el-submenu  v-if="subItem.subs"  :index="subItem.index" :key="subItem.index" >
                                <template  class="el-menu-item"   slot="title">
                                    {{ subItem.title }}
                                </template>
                                <el-menu-item   v-for="(threeItem,i) in subItem.subs" :key="i" :index="threeItem.index" >
                                    {{ threeItem.title }}
                                </el-menu-item>
                            </el-submenu>
                            <el-menu-item v-else  :index="subItem.index"  :key="subItem.index"  >
                                <span style='font-size: 30px; margin-top: -2px; margin-right: 3px;'> • </span> {{ subItem.title }}
                            </el-menu-item>
                        </template>
                    </el-submenu>
                </template>
                <template v-else>
                    <el-menu-item :index="item.index" :key="item.index">
                        <i :class="item.icon"></i>
                        <span slot="title">{{ item.title }}</span>
                    </el-menu-item>
                </template>
            </template>
        </el-menu>
    </div>
   
</template>

<script>
import bus from '../common/bus';
import { getItem } from '../../api/common/sidebar'; 
export default {
    inject: ['reload'],
    data() {
        return {
            drawer: false,
            closeFag:false,
            stationLogo:require('../../assets/img/side.png'), 
            stationName:'',
            phone:'',
            collapse: false,
            items: [    ]
            
            
            };
    },
    //监视
    watch: {
       //检测路由参数发生改变时，刷新当前页面 调用
       '$route': function(){
            // this.reload();
        }
    },
    computed: {
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },
    beforeMount:function () { 
        this.phone = localStorage.getItem(window.location.hostname+'_phone');
        this.stationName = localStorage.getItem(window.location.hostname+'_stationName');
        this.stationLogo = localStorage.getItem(window.location.hostname+'_stationLogo'); 
        
    },
    mounted: function () {  
    },
 
    created() {   
        var item = localStorage.getItem(window.location.hostname+'_items'); 
        if(item){
            this.items = JSON.parse(item);  
        }else{
            this.getItems(); 
        }
        
        if(performance.navigation.type==0){ 
            
        } else{
           // this.setItems(); 
        }
        let that = this;
        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        bus.$on('collapse', msg => { 
            this.collapse = msg;   
             if (document.body.clientWidth < 1000  ) {
                this.closeFag = msg; 
                document.getElementById('content-box').onclick = function(e) {  
                    if(!msg){
                        that.collapseChage(); 
                    }
                    
                }  
            }
        }); 
    },
    methods: { 
        handleselect: function (a, b) { 
            //this.reload()  // 点击侧边栏重新载入页面
            //this.router.go(0);
            
        },
        getItems(){  
            let data = {};   
            getItem(data).then(res => { 
                this.items = res.data;    
                localStorage.setItem(window.location.hostname+'_items', JSON.stringify(res.data));   
            }); 
        },
        setItems(){ 
            var items = "["+sessionStorage.getItem("items")+"]";  
            this.items = JSON.parse(items);    
        },
         // 侧边栏折叠
        collapseChage() {   
            this.collapse = !this.collapse;  
            this.closeFag = !this.collapse;
            bus.$emit('collapse', this.collapse);
            
        },
        //重置按钮
        refresh(){ 
            window.reload();
        }, 
    }
};
</script>
<style>
 
    .closeBtn{
        position:absolute;
        right:20px; 
    }
       .el-submenu__title i {
    color:#fff;
} 

</style>

<style scoped> 

    li i{
    color:#fff;
} 
 @media screen and (max-width:999px){ 
    .close{
        color:#fff;
        font-size:20px;
        float:right;
        margin-top:20px;
        margin-right:20px;
    }
    .logo{ 
        position: fixed;
        z-index: 100;
        height:60px;
        line-height: 60px;
        width:282px;
        align-items: center;
        justify-content: left;  
        overflow: hidden;
        white-space: nowrap;  
        top:0;
        opacity:1; 
    }
    .ref{
        margin-left:0px;
        margin-top:-5px;
    }
    .logo img{
        width:25px;
        height:25px;
    }

    .header{
        background: rgb(4,28,51);
    }
     .el-item{
          width: 260px;
     }
     .el-submenu{
        background: #000000  !important;

    } 
.sidebar-el-menu:not(.el-menu--collapse) {
        width: 280px;
        z-index: 10;
        opacity:0.9;
        height:100%;
    }
    
 }


 @media screen and (min-width:999px){ 
     .close{
         display:none;
     }
    .logo{ 
        position: fixed;  
        z-index: 100;
        height:60px;
        line-height: 60px;
        width:205px;
        align-items: center;
        justify-content: left;  
        overflow: hidden;
        white-space: nowrap; 
    }
     .closeBtn,.refresh,.ref{
        display:none;
    }
     .el-item{
          width: 205px;
     }
.sidebar-el-menu:not(.el-menu--collapse) {
        width: 205px;
        z-index: 10;
        opacity:0.9;
    } 
 
 }

.sidebar::-webkit-scrollbar {
    width: 0;
}
   .sidebar > ul {
    height: 100%;
    margin-top:56px;
}

 
</style>
